import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import instance from '@src/api/axiosInstance';

interface CreateTemplatePayload {
  query: string;
  extra_instructions: string;
  deep_mode: boolean;
  visibility: 'private' | 'team' | 'recommended';
  tags: string[];
}

const createAnalysisTemplate = async (data: CreateTemplatePayload): Promise<any> => {
  const response = await instance.post('/nexa/analysis-templates', data);
  return response.data;
};

export const useCreateAnalysisTemplate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createAnalysisTemplate,
    onSuccess: () => {
      message.success('Analysis template created successfully');
      queryClient.invalidateQueries({ queryKey: ['analysis-templates'] });
      queryClient.invalidateQueries({ queryKey: ['analysis-tags'] });
      queryClient.invalidateQueries({ queryKey: ['my-analyses'] });
      queryClient.invalidateQueries({ queryKey: ['team-analyses'] });
      queryClient.invalidateQueries({ queryKey: ['recommended-analyses'] });
    },
    onError: (error: any) => {
      message.error(error?.response?.data?.error?.message || 'Failed to create analysis template');
    },
  });
};
